import { ShareCartPayload } from '@cart/const';
import { StateUtils } from '@spartacus/core';

export const SHARE_CART = '[CustomCart] Share cart';
export const SHARE_CART_SUCCESS = '[CustomCart] Share cart success';
export const SHARE_CART_FAIL = '[CustomCart] Share cart fail';
export const SHARE_CART_RESET = '[CustomCart] Share cart reset';

export class ShareCart extends StateUtils.LoaderLoadAction {
  readonly type = SHARE_CART;

  constructor() {
    super(SHARE_CART);
  }
}

export class ShareCartSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SHARE_CART_SUCCESS;

  constructor(public payload: ShareCartPayload) {
    super(SHARE_CART);
  }
}

export class ShareCartFail extends StateUtils.LoaderFailAction {
  readonly type = SHARE_CART_FAIL;

  constructor(public payload: any) {
    super(SHARE_CART, payload);
  }
}

export class ShareCartReset extends StateUtils.LoaderResetAction {
  readonly type = SHARE_CART_RESET;

  constructor() {
    super(SHARE_CART);
  }
}

export type ShareCartActions = ShareCart | ShareCartSuccess | ShareCartFail | ShareCartReset;
